module.exports = __webpack_public_path__ + "media/images/application/template/arrow-down-f97046b0bd982b12912425416c3f1ae9.svg";